import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { HowItWorksPage } from './pages/HowItWorksPage';
import { GetInvolvedPage } from './pages/GetInvolvedPage';
import { ImpactPage } from './pages/ImpactPage';
import { BlogPage } from './pages/BlogPage';
import { PartnersPage } from './pages/PartnersPage';
import { FAQPage } from './pages/FAQPage';
import { ContactPage } from './pages/ContactPage';
import { DonatePage } from './pages/DonatePage';
import { CopticPeoplePage } from './pages/CopticPeoplePage';
import { Layout } from './components/layout/Layout';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<Layout data-id="element-3">
              <HomePage data-id="element-4" />
            </Layout>} data-id="element-2" />
        <Route path="/about" element={<Layout data-id="element-6">
              <AboutPage data-id="element-7" />
            </Layout>} data-id="element-5" />
        <Route path="/how-it-works" element={<Layout data-id="element-9">
              <HowItWorksPage data-id="element-10" />
            </Layout>} data-id="element-8" />
        <Route path="/get-involved" element={<Layout data-id="element-12">
              <GetInvolvedPage data-id="element-13" />
            </Layout>} data-id="element-11" />
        <Route path="/impact" element={<Layout data-id="element-15">
              <ImpactPage data-id="element-16" />
            </Layout>} data-id="element-14" />
        <Route path="/blog" element={<Layout data-id="element-18">
              <BlogPage data-id="element-19" />
            </Layout>} data-id="element-17" />
        <Route path="/partners" element={<Layout data-id="element-21">
              <PartnersPage data-id="element-22" />
            </Layout>} data-id="element-20" />
        <Route path="/faq" element={<Layout data-id="element-24">
              <FAQPage data-id="element-25" />
            </Layout>} data-id="element-23" />
        <Route path="/contact" element={<Layout data-id="element-27">
              <ContactPage data-id="element-28" />
            </Layout>} data-id="element-26" />
        <Route path="/donate" element={<Layout data-id="element-30">
              <DonatePage data-id="element-31" />
            </Layout>} data-id="element-29" />
        <Route path="/coptic-people" element={<Layout data-id="element-33">
              <CopticPeoplePage data-id="element-34" />
            </Layout>} data-id="element-32" />
      </Routes>
    </BrowserRouter>;
}